import {
  parseTeacherOccurrenceDetail,
  parseTeacherScheduleResponse
} from "@madamuh/domain";
import type {
  TeacherOccurrenceDetailDto,
  TeacherScheduleResponseDto
} from "@madamuh/domain";
import { apiGet } from "./client";

export async function fetchTeacherSchedule(tenantSlug: string): Promise<TeacherScheduleResponseDto> {
  const response = await apiGet<unknown>(`/api/v1/teacher/tenants/${tenantSlug}/schedule`);
  return parseTeacherScheduleResponse(response);
}

export async function fetchTeacherOccurrence(
  tenantSlug: string,
  occurrenceId: string
): Promise<TeacherOccurrenceDetailDto> {
  const response = await apiGet<unknown>(`/api/v1/teacher/tenants/${tenantSlug}/occurrences/${occurrenceId}`);
  return parseTeacherOccurrenceDetail(response);
}
